<div class="d-flex w-100">
	<div class="my-auto mx-auto">
		<img
			*ngIf="function === 'connect'"
			src="https://focuspos-onlineorder-images.s3.us-west-2.amazonaws.com/C2QB_green_btn_short_hover_2x.png"
			width="auto"
			height="100%"
			alt="connect to quickbooks"
			(click)="quickbooksConnect()"
		/>
		<p-button *ngIf="function === 'refresh'" pRipple styleClass="p-button-raised p-button-warning m-2" (click)="quickbooksRefresh()">
			<ng-template pTemplate="content">
				<div class="d-flex justify-content-center">
					<fa-icon [icon]="['far', 'sync']" size="lg" class="ms-1 me-2"></fa-icon>
					Refresh Connection
				</div>
			</ng-template>
		</p-button>
		<p-button *ngIf="function === 'disconnect'" pRipple styleClass="p-button-raised p-button-danger m-2" (click)="quickbooksDisconnect()">
			<ng-template pTemplate="content">
				<div class="d-flex justify-content-center">
					<fa-icon [icon]="['far', 'unlink']" size="lg" class="ms-1 me-2"></fa-icon>
					Disconnect from QuickBooks
				</div>
			</ng-template>
		</p-button>
	</div>
</div>
